<template>
  <div class="tiers">
    <ag-table :data-source-api="getAllTiers" :grid-options="gridOptions" :permissions="permissions" :rtl="false"
      :is-entities-response="false" @emitAddNewRecord="onCreateTier()" />
    <tm-popup :submit="onTierPopupSubmit" :title="tierPopupTitle" ref="tierPopup">
      <div class="vx-row justify-start">
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="اسم المستوى" placeholder="اسم المستوى" type="text" validation-rules="required"
            v-model="tier.name" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="عدد النقاط" placeholder="عدد النقاط" type="number" validation-rules="required"
            v-model="tier.pointsEquivalent" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-select class="w-full" :options="getTierStatusOptions" label="name" validation-rules="required"
            name="حالة المستوى" :reduce="name => name.value" v-model="tier.status" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mt-2 mb-2">
          <color-picker ref="colorPicker" :color="tier.color" v-model="tier.color" />
        </div>
      </div>
    </tm-popup>
  </div>
</template>

<script>
import { RepositoryFactory } from '../../loyalty-repositories/loyaltyRepositoryFactory';
import AgTable from '../../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import AgTableBtnCell from "../../../shared/shared-components/ag-grid/AgTableBtnCell";
import AgButton from "../../../shared/shared-components/ag-grid/AgButton";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmInput from "@/app/shared/shared-components/TmInput";
import FilePondComponent from "@/app/shared/shared-components/FilePondComponent";
import TmTextArea from "@/app/shared/shared-components/TmTextArea";
import TmSelect from "@/app/shared/shared-components/TmSelect";
import colorPicker from "@/app/shared/shared-components/colorPicker";

const tiersRepo = RepositoryFactory.get('tiersRepository');
export default {
  name: "Tiers",
  components: {
    AgTable,
    TmInput,
    AgTableBtnCell,
    TmPopup,
    AgButton,
    TmTextArea,
    FilePondComponent,
    TmSelect,
    colorPicker,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      tierPopupTitle: '',
      status: {
        active: 'فعّال',
        inactive: 'معطّل',
      },
      tier: {
        name: null,
        pointsEquivalent: null,
        status: 'active',
        color: '#4B364E',
      },
      permissions: {
        add: 'tiers_manage',
        edit: 'tiers_manage',
        delete: 'tiers_manage',
      }
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: 'اسم المستوى',
          field: 'name',
          filter: 'agTextColumnFilter',
          width: 200,
          sortable: false
        },
        {
          headerName: 'عدد النقاط',
          field: 'pointsEquivalent',
          filter: 'agNumberColumnFilter',
          width: 200,
          sortable: true
        },
        {
          headerName: 'اللون',
          field: 'color',
          filter: 'agTextColumnFilter',
          cellStyle: self.changeCellColor,
          width: 100,
        },
        {
          headerName: 'حالة المستوى',
          field: 'status',
          // filter: 'agTextColumnFilter',
          width: 200,
          sortable: true,
          valueGetter:
            function getObject(params) {
              return self.status[params.data.status] || '-';
            },
          filter: 'agSetColumnFilter',
          filterParams: {
            values: Object.keys(self.status),
            valueFormatter: value => self.status[value]
          }
        },
        {
          headerName: 'الإجراءات',
          field: 'id',
          cellRendererFramework: AgTableBtnCell,
          sortable: false,
          cellRendererParams: {
            deleteRecord: function (id) {
              self.onDeleteTier(id);
            },
            editRecord: function (tier) {
              self.onUpdateTier(tier);
            },
            actions: ['edit', 'delete'],
            permissions: self.permissions
          },
        }
      ];
    },
    async onDeleteTier(tierId) {
      await tiersRepo.removeTier(tierId);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    onUpdateTier(tier) {
      this.tierPopupTitle = 'تعديل معلومات المستوى';
      this.$refs.colorPicker.setColor(tier.color);
      Object.assign(this.tier, tier);
      this.$refs.tierPopup.open();
    },
    onCreateTier() {
      this.tierPopupTitle = 'إضافة مستوى جديد';
      this.resetTierForm();
      this.$refs.tierPopup.open();
    },
    changeCellColor(params) {
      return { 'color': params.node.data.color };
    },
    resetTierForm() {
      Object.assign(this.tier, {
        name: null,
        pointsEquivalent: null,
        status: 'active',
        color: '#4B364E',
      });
      this.$refs.colorPicker.setColor(this.tier.color);
    },
    async onTierPopupSubmit() {
      try {
        let res = null;
        const tierPayload = {
          ...this.tier,
          pointsEquivalent: parseInt(this.tier.pointsEquivalent)
        };
        if (this.tierPopupTitle == 'إضافة مستوى جديد') {
          res = await tiersRepo.createTier(tierPayload);
        } else {
          res = await tiersRepo.updateTier(tierPayload);
        }

        if (res.status === 201 || res.status === 200) {
          this.$refs.tierPopup.close();
          await this.gridApi.refreshServerSideStore({ purge: true });
        }
      } catch (err) {
        this.$refs.tierPopup.endLoading();
      }
    },
    async getAllTiers(query) {
      return await tiersRepo.fetchTiers(query);
    },
  },
  computed: {
    getTierStatusOptions() {
      return Object.keys(this.status).map(key => ({
        name: this.status[key],
        value: key
      }));
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
</script>